export const environment = {
  production: true,
  apiAuthenticate: 'https://portalapi.nomoh.com.br/auth',
  apiPessoa: 'https://portalapi.nomoh.com.br/pessoa',
  apiPessoaAdmin: 'https://portalapi.nomoh.com.br/pessoaAdmin',
  apiSistema: 'https://portalapi.nomoh.com.br/sistema',
  apiFuncionalidade: 'https://portalapi.nomoh.com.br/funcionalidade',
  apiPlano: 'https://portalapi.nomoh.com.br/plano',
  apiRole: 'https://portalapi.nomoh.com.br/role',
  redirectBardo: 'https://bardo.nomoh.com.br/',
  redirect401Url: 'https://nomoh.com.br',
};
